<div #sentinel class="sir-tab-group-v2__sentinel" aria-hidden="true"></div>

<div #bar class="sir-tab-group-v2__bar">
    <sirius-container>
        <ul class="sir-tab-group-v2__list" role="tablist">
            @for (tab of tabs(); track $index) {
                <li class="sir-tab-group-v2__item" [class.is-active]="$index === selectedIndex()">
                    <button
                        type="button"
                        role="tab"
                        class="sir-tab-group-v2__tab"
                        [id]="groupId + '-tab-' + $index"
                        [attr.aria-selected]="$index === selectedIndex()"
                        [attr.aria-controls]="groupId + '-panel-' + $index"
                        [tabindex]="$index === selectedIndex() ? 0 : -1"
                        (click)="onTabClick($index)"
                        (keydown)="onKeydown($event)"
                    >
                        {{ tab.title }}
                    </button>
                    <span class="sir-tab-group-v2__indicator" aria-hidden="true"></span>
                </li>
            }
        </ul>
    </sirius-container>
</div>

<sirius-container>
    <div class="sir-tab-group-v2__content">
        @if (topSpacer()) {
            <sirius-spacer></sirius-spacer>
        }
        <ng-content></ng-content>
    </div>
</sirius-container>
